import React, { useId } from 'react'
import PropTypes from 'prop-types'

const ConnectionsIcon = React.forwardRef(function ConnectionsIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M21 17.18V6.82C22.16 6.4 23 5.3 23 4C23 2.35 21.65 1 20 1C18.7 1 17.6 1.84 17.18 3H6.82C6.4 1.84 5.3 1 4 1C2.35 1 1 2.35 1 4C1 5.3 1.84 6.4 3 6.82V13.19C1.84 13.6 1 14.7 1 16C1 17.65 2.35 19 4 19C5.65 19 7 17.65 7 16C7 15.63 6.92 15.27 6.8 14.94L18.5 6.58C18.66 6.67 18.82 6.75 19 6.81V17.18C17.84 17.59 17 18.69 17 20C17 21.65 18.35 23 20 23C21.65 23 23 21.65 23 20C23 18.7 22.16 17.6 21 17.18ZM5 13.18V6.82C5.85 6.51 6.51 5.85 6.82 5H17.19C17.2 5.02 17.2 5.04 17.21 5.06L5.5 13.42C5.34 13.32 5.17 13.25 5 13.18Z"></path>
    </svg>
  )
})

ConnectionsIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

ConnectionsIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default ConnectionsIcon
